import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Display a single blog post.
 * 
 * @param {Object} post - The post content.
 * @returns A `blog-post-card` div.
 * 
 * @updated May 28, 2025.
 */

const BlogPostCard = ({ post }) => {
  return (
    <div className="blog-post-card">
      <Link to={`/blog/post/${post.slug}`} className="post-image">
        <img src={post.image} alt={post.title} />
      </Link>
      <div className="post-content">
        <div className="post-meta">
          <span className="post-category">{post.category}</span>
          <span className="post-date">{post.date}</span>
        </div>
        <h3>
          <Link to={`/blog/post/${post.slug}`}>{post.title}</Link>
        </h3>
        <p className="post-excerpt">{post.excerpt}</p>
        <Link to={`/blog/post/${post.slug}`} className="read-more">
          Read More
        </Link>
      </div>
    </div>
  );
};

export default BlogPostCard;
